<template lang="html">
<div>
  <section class="login" v-if="show == 1">
    <div class="row w-100" >
                           <div class="col-lg-6 mx-auto" style="padding-top:150px;">
                            <div style="background-color: #20582b;">
                               <img src='../../assets/nagam cropped.jpeg' style="position: relative; display: inline-block; left: 50%; transform: translate(-50%);" width="40%" height="auto">
                               </div>
                                <form class="pt-5" style="padding-top:1px !important;">
              <form @submit="onChange">
                <div class="mt-5">
                  <!-- <a class="btn btn-block btn-warning btn-lg font-weight-medium" href="../../index.html">Login</a> -->
                   <button type="submit" class="btn btn-success btn-lg btn-block" style="color: #fff;
    background-color: #040300;
    border-color: #040300;">Login</button>
                </div>
            
              </form>
            </form>
                             </div>
                          </div>
  </section>
        
  <section class="login" v-else-if="show == 0" style="padding-top:100px;">
    <div class="wrapper d-flex align-items-center auth login-full-bg">
       <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
                            <p style="position: absolute; color: White; top: 30%; left: 45%;">
                                <img src='../../assets/spinner.gif' /></p>
                        </div>
            
      <div class="row w-100" > 
       
        <div class="col-lg-6 mx-auto">
          
          <div class="auth-form-dark text-left p-5">
           <h2>Login</h2>
            <h4 class="font-weight-light">Hello! let's get started</h4>
            <div v-if="err">
            <div>
              <b-alert show :duration="duration">{{err}}</b-alert>
            </div>
          </div>
            <form class="pt-5">
              <form @submit="onSubmit">
                <div class="form-group">
                  <label for="exampleInputEmail1">Username</label>
                  <input type="text" class="form-control" id="exampleInputEmail1" v-model="login.username" required="" aria-describedby="emailHelp" placeholder="Username">
                  <i class="mdi mdi-account"></i>
                </div>
                <div class="form-group">
                  <label for="exampleInputPassword1">Password</label>
                  <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" v-model="login.password" required="">
                  <i class="mdi mdi-eye"></i>
                </div>
                <div class="mt-5">
                  <!-- <a class="btn btn-block btn-warning btn-lg font-weight-medium" href="../../index.html">Login</a> -->
                   <button type="submit" class="btn btn-success btn-lg btn-block">Sign In</button>
                </div>
                <div class="mt-3 text-center">
                  <a href="#" class="auth-link text-white">Forgot password?</a>
                </div>
              </form>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import axios from "axios";
import store from "../../store";
export default {
  name: "login",
  data() {
    return {
      login: {},
      errors: [],
      duration: 200,
      err: "",
      loading: false,
      show: 1,
    };
  },
  methods: {
    onChange(evt) {
      evt.preventDefault();
      this.show = 0;
    },
    onSubmit(evt) {
      this.loading = true;
      evt.preventDefault();
      axios
        .post(`https://sarpatnapi.leopardtechlabs.in/platform/login/`, this.login)
        .then((response) => {
          if (response.data.heartbeat == true) {
            store.commit("loginUser");
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("username", response.data.data.username);
            if (response.data.data.type == "admin") {
              localStorage.setItem("is_admin", true);
            }
            localStorage.setItem("id", response.data.data.id);
            this.$router.push("/");
          } else {
            this.loginError = true;
            this.err = response.data.message;
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loginError = true;
          console.log(e);
          this.err = e.response;
          this.errors.push(e);
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.main-panel {
  width: calc(100% - 0px);
  min-height: calc(100vh - 58px);
}
body {
  background-color: #f6f8fa;
}
</style>



// WEBPACK FOOTER //
// src/views/sample-pages/login.vue